import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-produtos-linha',
  templateUrl: './produtos-linha.component.html',
  styleUrls: ['./produtos-linha.component.scss']
})
export class ProdutosLinhaComponent implements OnInit {
  lines?:any[];
  public line: any = null;
  category: string = 'linhas';

  routParamCategory: string = '';
  routParamSubCategory: string = '';
  routParamSubSubCategory: string = '';

  slugToSearch: string = '';

  tags: any[] = [];
  productsList = []
  products: any;
  categories: any;
  parentSlug: any;
  isAmbiente = 0;
  loadingProducts = true;

  constructor(
    public apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit(): void {

    this.route.params.subscribe(async params => {
      if(params['categorySlug']){
        this.routParamCategory = params['categorySlug'];
        let categoryTemp: any = await this.apiService.getCategoryByIdSlug(this.routParamCategory)
        if(categoryTemp && categoryTemp.ambiente === 1) {
          this.isAmbiente = 1;
          this.slugToSearch = this.routParamCategory;
        } else{
          this.slugToSearch = "";
          this.isAmbiente = 0;
        }
      }
      if(params['subcategorySlug']){
        this.routParamSubCategory = params['subcategorySlug'];
        this.slugToSearch = this.routParamSubCategory;
        this.parentSlug = await this.apiService.getCategoryByIdSlug(this.routParamCategory);

      }
      if(params['subsubcategorySlug']){
        this.routParamSubSubCategory = params['subsubcategorySlug'];
        this.slugToSearch = this.routParamSubSubCategory;
        this.parentSlug = await this.apiService.getCategoryByIdSlug(this.routParamCategory);
      }

      await this.loadCategories();
      if(this.slugToSearch) {
        let category: any = await this.apiService.getCategoryByIdSlug(this.slugToSearch);
        if(category){
          this.products = await this.apiService.getFilteredProductsByCategories(category.id);
        }
      }
      await this.loadProductsCategories();

  })
}

  async checkHasProducts(subcategorias: any){
    if(!subcategorias) return;
    subcategorias.forEach(async (categoria: any) =>{
      let products = await this.apiService.getCategoriesWithProductsFiltered(categoria.id)
      if(products.length > 0){
        categoria.hasProducts = true;

      } else{
        categoria.hasProducts = false;
      }
    });
    return subcategorias
  }

  async loadCategories(){
    let category:any;
    if(!this.slugToSearch || this.isAmbiente){
      category = await this.apiService.getCategoryByIdSlug(this.routParamCategory);
    }else{
      category = await this.apiService.getCategoryByIdSlug(this.routParamSubCategory);
    }
    if(category && category.subcategorias){
      let subcategorias: any[] = category['subcategorias'];
      let tagsTemp = await this.checkHasProducts(subcategorias);
      if(!this.areArraysEqualBySlug(tagsTemp,this.tags)){
        this.tags = tagsTemp;
      }
    } else{
      this.tags = [];
    }
    this.line = category;
  }

  areArraysEqualBySlug(arr1:any, arr2:any) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i].slug !== arr2[i].slug) {
            return false;
        }
    }
    return true;
}

  async loadProductsCategories(){
    let categorie: any = await this.apiService.getCategoryByIdSlug(this.slugToSearch);
    this.products = [];

    if(categorie && categorie.subcategorias){
      let subCategories = categorie.subcategorias;

      await Promise.all(subCategories.map(async (c:any) => {
        let subCategoryProducts = await this.apiService.getFilteredProductsByCategories(c.id);
        if(subCategoryProducts.length > 0){
          subCategoryProducts.forEach((productTemp:any) => {
            let addProduct = true;
            this.products.forEach((product:any) => {
              if(productTemp.codPro === product.codPro){
                addProduct = false;
              }
            })
            if(addProduct){
              if(this.products.length > 0){
                this.products = [...this.products, productTemp];
              }
              else{
                this.products = [productTemp];
              }
            }
          })
        }
      }));
    } else if(categorie){
      this.products = await this.apiService.getFilteredProductsByCategories(categorie.id);
    }

    this.products = this.apiService.filterProducts(this.products, '');
    this.loadingProducts = false;
  }


  async navigateToSubCategory(category:any){
    let categoryParent:any = await this.apiService.loadProductLine(category.parent_id);
    if(category){
      this.router.navigate([`linhas/${categoryParent.slug}/${category.slug}`]);
    }
  }

  async navigateToSubSubCategory(subSubCategory:any){
    this.loadingProducts = true;
    let subCategory:any = await this.apiService.loadProductLine(subSubCategory.parent_id);
    let category:any = await this.apiService.loadProductLine(subCategory.parent_id);
     if(subCategory){
      this.router.navigate([`linhas/${category.slug}/${subCategory.slug}/${subSubCategory.slug}`]);
    }
  }



}
